import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { Controller, useWatch } from "react-hook-form";
import { InputBilingualStyled } from "./styled";
import TextField from "../TextField";
import InputWysiwyg from "../InputWysiwyg";

// แสดงช่องไทย/อังกฤษคู่กันเป็น 2 คอลัมน์ แทนแท็บสลับภาษาแบบเดิม
// ชื่อฟิลด์ (nameTh/nameEn) ส่งตรงเข้า Controller เหมือนเดิมทุกตัว
// schema/required และค่าที่ส่งไป API จึงไม่เปลี่ยน
const InputBilingual = ({
  theme_standard,
  control,
  errors,
  nameTh,
  nameEn,
  isWysiwyg,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const [valueTh, valueEn] = useWatch({ control, name: [nameTh, nameEn] });

  const _renderCol = (lang, name, value) => {
    const errorMsg = errors && errors[name]?.message;
    const text = _toPlainText(value, isWysiwyg);
    const status = _getStatus(text, errorMsg);
    return (
      <div className={`lang_col ${status.key}`}>
        <div className="lang_head">
          <div className="lang_label">{lang === "th" ? "ไทย" : "ENGLISH"}</div>
        </div>
        <Controller
          control={control}
          render={({ field }) =>
            isWysiwyg ? (
              <InputWysiwyg {...field} errors={errorMsg} />
            ) : (
              <TextField {...field} errors={errorMsg} />
            )
          }
          name={name}
          defaultValue=""
        />
        {!isWysiwyg && <div className="counter">{text.length} ตัวอักษร</div>}
      </div>
    );
  };

  return (
    <InputBilingualStyled>
      <div className={customClass}>
        <div className="lang_row">
          {_renderCol("th", nameTh, valueTh)}
          {_renderCol("en", nameEn, valueEn)}
        </div>
      </div>
    </InputBilingualStyled>
  );
};

// wysiwyg เก็บเป็น html และ editor ว่างก็ยังได้ "<p></p>" จึงต้องตัดแท็กออกก่อนเช็คว่ามีข้อความไหม
const _toPlainText = (value, isWysiwyg) => {
  if (value === undefined || value === null) return "";
  const str = String(value);
  if (!isWysiwyg) return str;
  return str
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
};

// สถานะของช่อง ใช้แค่ทำกรอบแดงตอน required แล้วว่าง (error ของ yup แสดงใต้ input อยู่แล้ว)
// (เอาป้ายเตือน "ดูเหมือนภาษาอังกฤษ/ไทย" ออกแล้วตามที่ผู้ใช้ขอ)
const _getStatus = (text, errorMsg) => {
  const isEmpty = text.trim() === "";
  if (errorMsg && isEmpty) {
    return { key: "is_error" };
  }
  if (isEmpty) {
    return { key: "is_empty" };
  }
  return { key: "is_filled" };
};

InputBilingual.propTypes = {};

export default InputBilingual;
